/*
 * File: ZoomList.tsx
 * Project: a-a
 * File Created: Friday, 24th October 2025 9:27:58 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Monday, 17th November 2025 11:23:47 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2025 Mutual Mobile, Mutual Mobile
 */
import { Box, Typography } from '@mui/material';
import { ReactComponent as InfoIcon } from '../../../../assets/information-circle.svg';
import ZoomColumnGrid from '../ZoomColumnGrid/ZoomColumnGrid';
import zeplinColor from '../../../../theme/Color';
import CustomButton from '../../../shared/CustomButton/CustomButton';
import styles from './zoomList.module.css';

const ZoomList = ({
  getData,
  data,
  loading,
  category,
}: {
  data: any;
  loading: boolean;
  getData: () => Promise<void>;
  category: string;
}) => {
  const title = {
    updates: 'Top updates',
    accounts: 'Target accounts',
    suggestion: 'Suggestion',
  };
  return (
    <>
      {data?.items?.length === 0 ? (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            height: 'calc(100vh - 180px)',
            gap: '32px',
          }}
        >
          {' '}
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '24px',
              width: '100%',
            }}
          >
            <img src={'/assets/no-zoominfo.svg'} className={styles['no-target-icon']} />
            <Typography
              variant='responsiveHeading3'
              color={zeplinColor.BasicBlack}
              sx={{ marginTop: '24px' }}
            >
              No {title[category as keyof typeof title]} Yet
            </Typography>
            {category === 'accounts' && (
              <Typography
                variant='responsiveBody3'
                color={zeplinColor.Neutral8}
                sx={{ width: '70%', textAlign: 'center', marginTop: '12px' }}
              >
                Get actionable insights on your high-priority companies
                <br /> by adding them as {title[category as keyof typeof title]}
              </Typography>
            )}
          </Box>
          {/* <CustomButton
            disabled={false}
            onClick={() => {}}
            variant='contained'
            // buttonVariant={'responsiveButtonMedium'}
            color={'primary'}
            style={{
              // width: '100%',

              borderRadius: '14px',
              height: 48,
              padding: '14px 16px',
              '&.Mui-focusVisible': { backgroundColor: '#333CAA' },
            }}
            textStyle={{ color: zeplinColor.Neutral1, fontSize: { xs: '14px', xl: '16px' } }}
            icon={<img src={`/assets/add-white.svg`} className={styles['add-icon']} />}
            text={'Add Target Account'}
            // tabindex={4}
          /> */}
        </Box>
      ) : (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
            <Typography variant='responsiveHeading3'>
              {category === 'updates'
                ? 'Top updates for today'
                : category === 'accounts'
                ? 'Target Accounts'
                : 'Whitespace Company updates'}
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <Typography variant='responsiveBody3' color={zeplinColor.Neutral8}>
                {category === 'updates'
                  ? 'Prioritized by signal strength and recency'
                  : category === 'accounts'
                  ? ''
                  : 'Potential new business in your broader target market'}
              </Typography>
              {/* {category === 'updates' && <InfoIcon width={18} height={18} />} */}
            </Box>
          </Box>
          <ZoomColumnGrid
            data={data}
            getData={getData}
            loading={loading}
            getUpdates={getData}
            category={category}
          />
        </Box>
      )}
    </>
  );
};

export default ZoomList;
